export enum SearchDataLayerEnums {
  SearchSuggestionsInViewEventGTM = 'SearchSuggestionsInViewEventGTM',
}

export enum AnalyticEventLabelViewTypes {
  search = 'search',
  category = 'category',
  frequentSearch = 'frequentSearch',
  recipes = 'recipes',
  previousSearch = 'previousSearch',
}
